import './index.css';

interface Props {
  label: string;
  date: string | undefined;
  handleDateChange: (date: string) => void;
}

const InputDate = (props: Props) => {
  const { label, date, handleDateChange } = props;

  return (
    <div>
      <h3 className="candles-form-item-label">{label}: </h3>
      <input
        type="date"
        id="start-date"
        value={date}
        onChange={(event) => handleDateChange(event.target.value)}
      />
    </div>
  );
};

export default InputDate;
